import React, { FC } from 'react';


const ZotaLoader: FC = (): JSX.Element => {

  return (
    <>
      <h2 className="animate">ZØTAPAY</h2>
    </>
  );
};

export default ZotaLoader;